<div class="h-screen">

  <div class="flex justify-between items-center mb-2">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Cadastro de Fornecedor</h1>
    </div>
    <div class="flex items-center" *ngIf="form">
      <p-checkbox
        [ngModel]="form.get('active')?.value"
        (ngModelChange)="form.patchValue({ active: $event })"
        [ngModelOptions]="{standalone: true}"
        binary="true"
        inputId="cbAtivo">
      </p-checkbox>
      <label for="cbAtivo" class="ml-2">Ativo</label>
    </div>
  </div>

  <div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
      <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
        <div class="col-span-5">
          <label class="block mb-1 font-medium">Razão Social <span class="text-red-500">*</span></label>
          <div class="flex flex-col">
            <input
              pInputText
              formControlName="companyName"
              placeholder="Digite a razão social"
              class="w-full"
            />
            <small class="text-red-500" *ngIf="isFieldInvalid('companyName')">Obrigatório.</small>
          </div>
        </div>
      </div>

      <div class="grid mt-4 grid-cols-1 md:grid-cols-6 gap-6">
        <div class="col-span-2">
          <label class="block mb-1 font-medium">Cnpj</label>
          <p-inputmask
            mask="99.999.999/9999-99"
            formControlName="cnpj"
            placeholder="Digite o CNPJ"
            class="w-full"
          ></p-inputmask>
        </div>
        <div class="col-span-2">
          <label class="block mb-1 font-medium">Ie</label>
          <input
            pInputText
            formControlName="stateRegistration"
            placeholder="Digite a Inscrição Estadual"
            class="w-full"
          />
        </div>

        <div class="col-span-2">
          <label class="block mb-1 font-medium">Fantasia</label>
          <input
            pInputText
            formControlName="tradingName"
            placeholder="Digite o nome fantasia"
            class="w-full"
          />
        </div>
      </div>

      <div class="grid mt-4 grid-cols-1 md:grid-cols-5 gap-6">
        <div>
          <label class="block mb-1 font-medium">Cep</label>
          <p-inputmask
            mask="99999-999"
            formControlName="zipCode"
            placeholder="Digite o CEP"
            class="w-full"
          ></p-inputmask>
        </div>
        <div class="md:col-span-2">
          <label class="block mb-1 font-medium">Endereço</label>
          <input
            pInputText
            formControlName="address"
            placeholder="Digite o endereço"
            class="w-full"
          />
        </div>
        <div>
          <label class="block mb-1 font-medium">Número</label>
          <input
            pInputText
            formControlName="addressNumber"
            placeholder="Digite o numero"
            class="w-full"
          />
        </div>
        <div>
          <label class="block mb-1 font-medium">Complemento</label>
          <input
            pInputText
            formControlName="addressComplement"
            placeholder="Digite o complemento"
            class="w-full"
          />
        </div>
      </div>

      <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
        <div class="md:col-span-2">
          <label class="block mb-1 font-medium">Bairro</label>
          <input
            pInputText
            formControlName="district"
            placeholder="Digite o bairro"
            class="w-full"
          />
        </div>
        <div>
          <label class="block mb-1 font-medium">Unidade Federativa</label>
          <p-select
            formControlName="state"
            [options]="states"
            optionLabel="description"
            optionValue="acronym"
            placeholder="Selecione o estado"
            class="w-full"
            [filter]="true"
            (onChange)="getCities($event)"
          ></p-select>
        </div>
        <div>
          <label class="block mb-1 font-medium">Cidade</label>
          <p-select
            formControlName="city"
            [options]="cities"
            optionLabel="description"
            optionValue="description"
            placeholder="Selecione a cidade"
            class="w-full"
            [filter]="true"
          ></p-select>
        </div>
      </div>

      <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
        <div>
          <label class="block mb-1 font-medium">Telefone Fixo</label>
          <p-inputmask
            mask="(99) 9999-9999"
            formControlName="phone"
            placeholder="Telefone"
            class="w-full"
          ></p-inputmask>
        </div>
        <div>
          <label class="block mb-1 font-medium">Celular</label>
          <p-inputmask
            mask="(99) 99999-9999"
            formControlName="mobilePhone"
            placeholder="Celular"
            class="w-full"
          ></p-inputmask>
        </div>
        <div>
          <label class="block mb-1 font-medium">WhatsApp</label>
          <p-inputmask
            mask="(99) 99999-9999"
            formControlName="whatsApp"
            placeholder="WhatsApp"
            class="w-full"
          ></p-inputmask>
        </div>
        <div>
          <label class="block mb-1 font-medium">Email</label>
          <input
            pInputText
            type="email"
            formControlName="email"
            placeholder="Digite o e-mail"
            class="w-full"
          />
        </div>
      </div>

      <div class="flex justify-end gap-3">
        <button (click)="goBack()" type="button" class="border px-2 border-orange-500 cursor-pointer rounded">Cancelar</button>
        <button
          type="submit"
          class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white"
        >
          {{ isEditMode ? 'Salvar' : 'Cadastrar' }}
        </button>
      </div>
    </form>
  </div>
</div>
